import React from 'react';

import { ISiteContext, SiteContext } from './context';
import { OfferFilter } from './gqlTypes/OfferFilter';
import { Site_site } from './gqlTypes/Site';
// REST API migration - Apollo removed from main bootstrap
// Original: import { useSiteQuery } from './queries';
import { useSiteQuery } from './queries.rest';

export const SiteProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { data } = useSiteQuery();

  return (
    <SiteContext.Provider
      value={(data?.site ? getAvailableOfferFilters(data.site) : undefined) as ISiteContext}
    >
      {children}
    </SiteContext.Provider>
  );
};

const getAvailableOfferFilters = (data: Site_site) => {
  const site = data as ISiteContext;
  site.availableOfferFilters = [
    //  TODO: What about those? Move all of this to the api only to have 'keys'?
    'stawkaOd',
    'stawkaDo',
    ...(Object.values(data.offerFilters) as OfferFilter[])
      .map(({ slug }) => slug)
      .filter((v) => v),
  ];
  return site;
};
